<template>
  <div class="go-top" v-if="isShowGoTopButton" @click="goTop">
    <img src="../assets/gotop.png" /><br/>
  </div>
</template>

<script>
export default {
  name: "go-top",
  data(){
    return {
      isShowGoTopButton: false,
      btnStyle: false
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll); // 监听滚动事件
  },
  methods: {
    goTop() {
      window.scrollTo({top: 0, behavior: 'smooth'}); // 平滑滚动到顶部
    },
    handleScroll() {
      if (window.pageYOffset > 500) { // 判断滚动位置大于1043px时显示返回顶部按钮
        this.isShowGoTopButton = true;
      } else {
        this.isShowGoTopButton = false;
      }
    }
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll); // 移除滚动事件监听器
  }
}
</script>

<style scoped>
.go-top{
  position: fixed;
  bottom: 139px;
  right: 5%;
  cursor: pointer;
  opacity: 0.1;
}
.go-top:hover{
  opacity: 1;
}
</style>



// WEBPACK FOOTER //
// src/common/go-top.vue